import { normalizeRules } from 'vee-validate';
import type { FormFieldProps } from '@/mixins/FormField';

export function useNormalizedFormRules(rules: FormFieldProps['rules']) {
  return computed(() => {
    if (!rules) {
      return {};
    }

    // Prevent mutating passed rules prop
    const rulesToNormalize = deepClone(rules);

    // Normalize `max` rule
    if (rulesToNormalize?.max === '') {
      rulesToNormalize.max = false;
    }

    // Normalize using vee-validate functions
    return normalizeRules(rulesToNormalize);
  });
}
